<template>
  <div id="modalMeasureAvaliation" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-full">
      <div v-if="!isLoading" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <div class="modal-body">
          <StepsMeasure :status="measure.status" :logs="measure.logs" />
          <hr />
          <CertificationMeasure
            v-if="measure.type === 'Contrato'"
            :measure="measure"
          />
          <hr />
          <ItemsMeasure
            :items="measure.itens"
            :totalValue="measure.totalValue"
          />
          <hr />
          <div class="text-end">
            <button
              v-if="
                isFinancialManager &&
                [
                  MeasureStatusEnum.AGUARDANDO_APROVACAO,
                  MeasureStatusEnum.APROVADO_GESTOR,
                  MeasureStatusEnum.REPROVADO,
                ].includes(measure.status)
              "
              class="btn btn-warning rounded-pill ms-2"
              title="Cancelar Medição"
              :disabled="disableButton"
              @click="showInputCancelForm"
            >
              Cancelar Medição
            </button>
            <button
              v-if="
                (isManager &&
                  measure.status === MeasureStatusEnum.AGUARDANDO_APROVACAO) ||
                (isFinancialManager &&
                  measure.status === MeasureStatusEnum.APROVADO_GESTOR)
              "
              class="btn btn-danger rounded-pill ms-2"
              title="Reprovar Medição"
              :disabled="disableButton"
              @click="showInputReprovationForm"
            >
              Reprovar Medição
            </button>
            <button
              v-if="
                isManager &&
                measure.status === MeasureStatusEnum.AGUARDANDO_APROVACAO
              "
              class="btn btn-success rounded-pill ms-2"
              title="Aprovar Medição"
              :disabled="disableButton"
              @click="
                avaliationMeasure(
                  measure.id,
                  MeasureStatusEnum.APROVADO_GESTOR,
                  'Manager',
                )
              "
            >
              Aprovar como Gerente
            </button>
            <button
              v-if="
                isFinancialManager &&
                measure.status === MeasureStatusEnum.APROVADO_GESTOR
              "
              class="btn btn-success rounded-pill ms-2"
              title="Aprovar Medição"
              :disabled="disableButton"
              @click="showInputPaymentDateForm"
            >
              Aprovar como Ger. Financeira
            </button>
          </div>
          <div v-if="showCancelForm">
            <hr />
            <h5 class="fw-light mb-2">Justificativa:</h5>
            <textarea
              class="form-control"
              rows="3"
              v-model="reprovationJustify"
              placeholder="Informe a justificativa do cancelamento da medição..."
            />
            <div class="text-end mt-3">
              <button
                class="btn btn-info rounded-pill"
                title="Voltar"
                :disabled="disableButton"
                @click="showCancelForm = false"
              >
                Voltar
              </button>
              <button
                class="btn btn-warning rounded-pill ms-2"
                title="Confirmar Cancelamento"
                :disabled="disableButton"
                @click="
                  avaliationMeasure(
                    measure.id,
                    MeasureStatusEnum.CANCELADO,
                    'Financial',
                  )
                "
              >
                Confirmar Cancelamento
              </button>
            </div>
          </div>
          <div v-if="showReprovationForm">
            <hr />
            <h5 class="fw-light mb-2">Justificativa:</h5>
            <textarea
              class="form-control"
              rows="3"
              v-model="reprovationJustify"
              placeholder="Informe a justificativa pela qual a medição foi reprovada..."
            />
            <div class="text-end mt-3">
              <button
                class="btn btn-info rounded-pill"
                title="Voltar"
                :disabled="disableButton"
                @click="showReprovationForm = false"
              >
                Voltar
              </button>
              <button
                class="btn btn-danger rounded-pill ms-2"
                title="Reprovar"
                :disabled="disableButton"
                @click="
                  avaliationMeasure(
                    measure.id,
                    MeasureStatusEnum.REPROVADO,
                    isManager &&
                      measure.status == MeasureStatusEnum.AGUARDANDO_APROVACAO
                      ? 'Manager'
                      : 'Financial',
                  )
                "
              >
                {{
                  isManager &&
                  measure.status == MeasureStatusEnum.AGUARDANDO_APROVACAO
                    ? 'Reprovar como Gerente'
                    : 'Reprovar como Ger. Financeira'
                }}
              </button>
            </div>
          </div>
          <div v-if="showPaymentDateForm">
            <hr />
            <h5 class="fw-light mb-2">Data de Pagamento:</h5>
            <input
              type="date"
              class="form-control"
              v-model="paymentDate"
              placeholder="Informe a data de pagamento"
            />
            <div class="text-end mt-3">
              <button
                class="btn btn-info rounded-pill"
                title="Voltar"
                :disabled="disableButton"
                @click="showPaymentDateForm = false"
              >
                Voltar
              </button>
              <button
                class="btn btn-success rounded-pill ms-2"
                title="Aprovar"
                :disabled="disableButton"
                @click="
                  avaliationMeasure(
                    measure.id,
                    MeasureStatusEnum.FATURADO,
                    'Financial',
                  )
                "
              >
                Aprovar
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer pt-0">
          <button
            type="button"
            class="btn btn-link"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepsMeasure from '@/components/documents/commons/measure/StepsMeasure.vue'
import CertificationMeasure from '@/components/documents/commons/measure/CertificationMeasure.vue'
import ItemsMeasure from '@/components/documents/commons/measure/ItemsMeasure.vue'
import { mapGetters } from 'vuex'
import MeasureStatusEnum from '@/enum/measureStatusEnum'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'MeasureAvaliationModal',

  props: {
    measureId: {
      type: String,
      required: true,
    },
  },

  components: {
    StepsMeasure,
    CertificationMeasure,
    ItemsMeasure,
  },

  data() {
    return {
      title: '',
      isLoading: true,
      showCancelForm: false,
      showReprovationForm: false,
      showPaymentDateForm: false,
      reprovationJustify: '',
      paymentDate: '',
      MeasureStatusEnum,
      disableButton: false,
    }
  },

  computed: {
    ...mapGetters(['isManager', 'isFinancialManager']),
  },

  methods: {
    async getMeasure() {
      try {
        this.measure = await this.$store.dispatch('getMeasure', this.measureId)

        if (this.measure.status === MeasureStatusEnum.AGUARDANDO_APROVACAO) {
          this.title = 'Avaliação do Gestor'
        } else {
          this.title = 'Avaliação da Ger. Financeira'
        }

        this.isLoading = false
        showModal('modalMeasureAvaliation')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    showInputCancelForm() {
      this.showCancelForm = true
      this.showReprovationForm = false
      this.showPaymentDateForm = false
    },

    showInputReprovationForm() {
      this.showCancelForm = false
      this.showReprovationForm = true
      this.showPaymentDateForm = false
    },

    showInputPaymentDateForm() {
      this.showCancelForm = false
      this.showReprovationForm = false
      this.showPaymentDateForm = true
    },

    async avaliationMeasure(measureId, status, type) {
      try {
        if (
          (MeasureStatusEnum.CANCELADO === status ||
            MeasureStatusEnum.REPROVADO === status) &&
          !this.reprovationJustify
        ) {
          this.$root.$refs.notification.warning('Informe uma justificativa.')
          return
        }

        if (MeasureStatusEnum.FATURADO === status && !this.paymentDate) {
          this.$root.$refs.notification.warning('Informe a data de pagamento.')
          return
        }

        this.disableButton = true
        let response = null

        if (this.measure.type === 'Contrato') {
          response = await this.$store.dispatch('updateContractMeasure', {
            idContract: this.measure.contractId,
            measureId,
            status,
            type,
            paymentDate: this.paymentDate,
            reprovationJustify: this.reprovationJustify,
          })
        } else {
          response = await this.$store.dispatch('updateMovimentMeasure', {
            idmov: this.measure.idmov,
            measureId,
            status,
            type,
            paymentDate: this.paymentDate,
            reprovationJustify: this.reprovationJustify,
          })
        }

        hideModal()
        this.$emit('closeModal', true)
        this.$root.$refs.notification.success(response.message)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getMeasure()
  },

  beforeUnmount() {
    hideModal()
    this.$emit('closeModal', false)
  },
}
</script>
